import React, { useCallback } from 'react';
import { color } from '@nuvolo/nuux-theme/utils';
import { TMMChip } from '#/common/utils/wrappers/withChip';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { DevExtremeFilterTriple, FilterChip, LogicalOperator } from './util';
import { SearchQuery } from '#/common/hooks/useSearchQuery';

export type FilterChipsProps = {
  activeFilters: FilterChip[];
  onFilterChange: (newFilters: FilterChip[]) => void;
};

const MAX_VISIBLE_CHIPS = 3;

export const FilterChips: React.FC<FilterChipsProps> = ({ activeFilters, onFilterChange }) => {
  const visibleChips = activeFilters.slice(0, MAX_VISIBLE_CHIPS);

  const onChipDelete = useCallback(
    (label: string) => {
      const updated = activeFilters.filter((c) => c.label !== label);
      onFilterChange(updated);
    },
    [activeFilters, onFilterChange],
  );

  const handleClearAll = useCallback(() => {
    onFilterChange([]);
  }, []);

  if (visibleChips.length === 0 && activeFilters.length === 0) {
    return null;
  }

  return (
    <NuvoBox display="flex" gap={8} flexWrap="wrap">
      {visibleChips.map((chip) => (
        <TMMChip
          key={chip.label}
          label={chip.label}
          type="info"
          canDelete
          customColors={
            chip.customColors ?? {
              backgroundColor: color('info', 'light3'),
              textColor: color('info', 'dark'),
            }
          }
          onDelete={() => onChipDelete(chip.label)}
        />
      ))}

      <div onClick={handleClearAll}>
        <TMMChip
          label={`Clear All (${activeFilters.length})`}
          type="info"
          customColors={{
            backgroundColor: color('primary', 'dark'),
            textColor: color('custom', 'lightContrastText'),
          }}
        />
      </div>
    </NuvoBox>
  );
};
